import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import useDidMount from 'app/hook/common/useDidMount';
import useAccordion from 'app/hook/common/useAccordion';

import classNames from 'classnames/bind';
import styles from './DiagnosisIntroStatic.module.scss';

const cx = classNames.bind(styles);

function DiagnosisIntroStatic() {
	const dataInfo = [
		{
			advantage: (
				<>
					프레임 정상 차량만 진단차량으로
					<br />
					등록 할 수 있습니다.
				</>
			),
			content: (
				<>
					프레임은 외부 충격시 승객의 안전과 직결되어
					<br />
					심각한 손상이 있는 경우 서비스 이용을 제한합니다.
				</>
			),
		},
		{
			advantage: (
				<>
					진단차량은 외부패널 교환도
					<br />
					안심하고 구매하실 수 있습니다.
				</>
			),
			content: (
				<>
					외부패널 교환 차량은 해당 부위에 둘러 쌓인
					<br />
					프레임을 정밀 진단합니다.
				</>
			),
			subCont: (
				<Link
					to="/cars/report/diagnosis-standard#part"
					className={cx('link')}
				>
					부위별 진단항목
				</Link>
			),
		},
		{
			advantage: (
				<>
					차량가격을 결정짓는 옵션, 등급을
					<br />
					AI 기술로 정확하게 진단합니다.
				</>
			),
			content: (
				<>
					차량의 연/월식에 따라 같은 모델도 등급이 다르고,
					<br />
					등급에 따라 가격이 다르기에 정확한 확인이 필요합니다.
				</>
			),
			description: (
				<>
					옵션의 유무를 확인하여 진단합니다.
					<br />
					작동 유무와 순정 여부는 확인하지 않습니다.
				</>
			),
		},
		{
			advantage: (
				<>
					진단마스터가 진단한 내용을
					<br />
					엔카가 책임집니다.
				</>
			),
			content: (
				<>
					진단결과 오류 확인 시 구매 후 90일 이내
					<br />
					또는 5,000km 이내에 규정에 따라 보상해 드립니다.
				</>
			),
			description: (
				<>
					기간, 주행거리 중 먼저 도래하는 것이 있으면
					<br />
					보증기간은 만료됩니다.
				</>
			),
			subCont: (
				<Link
					to="/cars/report/diagnosis-range"
					className={cx('link')}
				>
					보상범위 자세히보기
				</Link>
			),
		},
	];
	const infoMap = dataInfo.map((cont, index) => {
		const indexKey = index;
		return (
			<div
				key={indexKey}
				className={cx('list_advantage', `area_${index + 1}`)}
			>
				<strong className={cx('tit_advantage')}>{cont.advantage}</strong>
				<p className={cx('txt_advantage')}>{cont.content}</p>
				{cont.description && <p className={cx('txt_desc')}>{cont.description}</p>}
				{cont.subCont && <p className={cx('txt_sub')}>{cont.subCont}</p>}
			</div>
		);
	});
	const dataQnA = [
		{
			title: 'Q. 엔카진단은 누가, 왜 하는건가요?',
			content:
				'엔카진단은 개인, 매매업자(딜러) 모두가 이용할 수 있는 서비스입니다. 불신으로 인해 고객에게 신뢰를 잃어가는 중고차 시장에서 판매자가 엔카진단을 통해 구매자에게 투명하게 정보를 공개하여 신뢰할 수 있는 매물을 등록하기 위해 사용하는 서비스입니다.',
		},
		{
			title: 'Q. 같은 등급의 차량의 옵션이 다를 수 있나요?',
			content:
				'제조사에서 출시된 차량의 연,월식에 따라서 사양이 변경되는 경우가 있어서, 같은 등급의 차량이라도 옵션의 추가나 삭제가 있을 수 있으며, 금액이 같은 차량이라도 편의 장치 유무가 다를 수 있으므로 구매 전 충분한 비교를 통해 구매하시기 바랍니다.',
		},
		{
			title: 'Q. 주요골격(프레임)/외부패널이 뭔가요?',
			content: (
				<>
					차량의 뼈대는 철판과 철판이 서로 용접으로 접합되어서, 차량의 사고나 외부 충격 시 승객의 안전을 지켜주는데, 이를
					주요골격(프레임)이라고 하며 외부패널은 주요골격 부위에 용접이 아닌 볼트로 체결되어 달려있는 부위입니다.
					<br />
					후드(본넷), 프론트휀더, 도어, 트렁크 등이 외부패널에 속합니다. 볼트로 체결되어 쉽게 탈거할 수 있다면 외부패널,그렇지 않고 용접으로
					되어 있다면 프레임으로 보셔도 됩니다.
				</>
			),
		},
		{
			title: 'Q. 사고차는 어떻게 구분하나요?',
			content: (
				<>
					자동차관리법상 사고차는 주요골격(프레임) 부위의 판금, 용접수리 및 교환이 있는 경우로 한정하고 있습니다.
					<br />
					(쿼터패널, 루프패널, 사이드실패널은 절단, 용접 시에만 사고로 구분하며 판금수리는 사고에서 제외됩니다)
					<br />
					외부패널과 범퍼의 판금, 용접수리 및 교환은 단순수리로 사고차에 포함되지 않습니다. 보험처리이력 여부나 교환된 부위의 유무가
					사고차를 구분짓는 것은 아닙니다.
				</>
			),
		},
		{
			title: 'Q. 하부누유나 성능적인 부분도 확인하나요?',
			content: '엔카진단은 사고평가, 옵션, 등급체크 등의 확인을 진행하며, 하부누유나 성능적인 부분을 확인하지는 않습니다.',
		},
		{
			title: 'Q. 진단차량만 따로 모아서 볼 수 없나요?',
			content: (
				<>
					* 사이트
					<br />
					1) 국산/수입차 카테고리의 하부카테고리에서 &#39;엔카진단차량&#39;을 클릭하면 진단등록된 차량을 확인 할 수 있습니다.
					<br />
					2) 국산/수입차 카테고리의 좌측 검색단 하부의 엔카서비스에서 &#39;엔카진단&#39;체크를 통해 진단차량을 구분지어 볼 수 있습니다.
					<br />
					<br />* 모바일에서는 검색 더보기를 통해 엔카서비스에서 &#39;엔카진단&#39;체크로 상세검색이 가능합니다.
				</>
			),
		},
		{
			title: 'Q. 보험이력이 있는데 괜찮은가요?',
			content: (
				<>
					사고평가는 과거의 사고를 추측하는 것이 아닌 평가 시점의 현상태의 수리, 교환된 부위를 확인하여 사고유무를 구분짓는 것입니다.
					카히스토리 사이트에서 제공하는 사고이력, 보험이력은 말 그대로 보험처리된 내용을 전산상에 남기고 공개하는 것입니다.
					<br />
					실제 사고에 의한 보험처리도 있을 수 있고, 단순한 주정차 시 발생하는 처리도 있을 수 있는데, 작은 사고라도 사고차가 될 수도 있지만
					반대로 보험처리이력 여부나 진단 부위의 유무가 사고차를 구분짓는 것은 아닙니다.
					<br />
					보험이력은 사고평가의 절대적인 자료가 될 수 없으니, 엔카진단이나 성능상태점검기록부를 확인하시기 바랍니다.
				</>
			),
		},
		{
			title: 'Q. 성능상태점검기록부와는 다른건가요?',
			content:
				"중고차 매매업자가 자동차 판매를 위해 반드시 점검을 받아야 하는 내용이 '성능상태점검기록부'입니다. 성능상태점검기록부는 의무점검, 엔카진단차량은 소비자와 소통하기 위한 추가점검이라 생각하셔도 좋습니다.",
		},
		{
			title: 'Q. 진단받는 경우나 절차가 어떻게 되나요?',
			content:
				'진단등록된 차량의 평가내용 중 사고, 등급, 옵션상의 오류 발생 시 엔카로 문의하시기 바랍니다. 실차 확인 후 엔카 보상기준에 의거하여 보상해 드립니다. 보상은 진단 차량을 구매한 경우에 가능하며, 구매한 차량의 양도계약서 금액을 기준으로 감가율을 적용하여 진행됩니다. (양도계약서가 없을 시 과세표준금액을 기준으로 적용되며, 거래금액은 구입한 시기 평균 시세의 10% 이상은 인정받지 못합니다.)',
		},
		{
			title: 'Q. 계약이나 명의변경(이전)은 어떻게 하나요?',
			content: (
				<>
					1) 차주가 매매업자(딜러)라면 업자가 속해있는 상사를 통해 계약과 명의변경을 해결할 수 있습니다.
					<br />
					명의변경 과정에서 취등록세 납부를 위한 비용이 발생합니다. 일반적으로 상사에서 비용을 사전에 여유있게 받아서 명의변경을 마치고 남은
					비용을 다시 돌려드리는 절차로 진행됩니다. 반드시 취등록세 납부 영수증을 확인하시기 바랍니다.
					<br />
					<br />
					2) 차주가 개인이라면 자동차등록사업소로 차주와 구매자가 같이 방문하여 계약서 작성과 명의변경을 동시에 진행하시면 됩니다. 현재
					차량등록사업소 전국 어디에서나 명의변경이 가능합니다. 개인간 거래의 자세한 내용은 차량등록사업소에 문의하시거나 엔카 사이트의
					&#39;매매가이드&#39;를 참고하시기 바랍니다.
				</>
			),
		},
	];
	const { setAccordionLength, accordionArray, handleAccordionMulti } = useAccordion();
	useDidMount(() => {
		setAccordionLength(dataQnA.length);
	});
	const qnaMap = dataQnA.map((item, i) => (
		<dl key={item.title}>
			<dt className={cx('txt_question', { on: accordionArray[i] })}>
				<button
					type="button"
					className={cx('view_answer')}
					onClick={() => handleAccordionMulti(i)}
					data-enlog-dt-eventname="자주묻는질문"
				>
					{item.title}
				</button>
			</dt>
			<dd className={cx('txt_anwser', { on: accordionArray[i] })}>{item.content}</dd>
		</dl>
	));
	const [open, setOpen] = useState();
	const handleClick = () => {
		setOpen(!open);
	};
	return (
		<>
			<div className={cx('cont_visual')}>
				<h3 className={cx('tit_diagnosis')}>엔카진단</h3>
				<strong className={cx('txt_diagnosis')}>
					엔카가 확인하고 엄선한,
					<br />
					엔카진단 차량
				</strong>
				<ul className={cx('item_list')}>
					<li>
						엔카 진단마스터
						<br />
						직접 검증
					</li>
					<li>
						사고&middot;옵션 유/무,
						<br />
						등급, 옵션 보장
					</li>
					<li>
						진단에 대해
						<br />
						책임
					</li>
				</ul>
			</div>
			<div className={cx('about_diagnosis')}>
				<h4 className={cx('tit_introduce')}>엔카진단 차량이란?</h4>
				<p className={cx('txt_introduce')}>
					엔카의 경험과 노하우로 등급, 사고&middot;옵션 유/무를
					<br />
					확인하고 등록한 차량입니다.
				</p>
			</div>
			<div className={cx('why_diagnosis')}>
				<h4 className={cx('tit_why_diagnosis')}>왜 안심하고 구매할 수 있을까요?</h4>
				<div className={cx('item_advantage')}>{infoMap}</div>
			</div>
			<div className={cx('wrap_question')}>
				<div className={cx('area_question')}>
					<h4 className={cx('tit_question')}>자주 묻는 질문</h4>
					<div className={cx('list_question', { open })}>{qnaMap}</div>
					<button
						type="button"
						onClick={handleClick}
						className={cx('btn_more')}
					>
						<span>{open ? '접기' : '펼쳐보기'}</span>
					</button>
				</div>
			</div>
		</>
	);
}

export default DiagnosisIntroStatic;
